import './cocktail-header.js';
import './cocktail-list.js';
import './cocktail-stats.js';
import './cocktail-modal.js';
import { errorBoundary } from '../errorBoundary.js';
import { Log } from '../logger.js';
// Initialize router for client-side routing
import '../router.js';

const _log = Log('cocktail-app.js');

class CocktailApp extends HTMLElement {
  connectedCallback() {
    _log.green('Cocktail app connected');
    this.render();
  }

  render() {
    // New layout: header with search, stats, card grid, and modal
    this.innerHTML = `
      <div class="app-container">
        <cocktail-header></cocktail-header>
        <cocktail-stats></cocktail-stats>
        <main class="main-content">
          <cocktail-list></cocktail-list>
        </main>
        <cocktail-modal></cocktail-modal>
      </div>
    `;
  }
}

customElements.define('cocktail-app', CocktailApp);
